import {PaginationList} from '../../../../shared/models/product/product-list/pagination-list';
import {Coupon} from './coupon';
import {decoratorType} from 'lib-shared';
import {Type} from 'class-transformer';

export class CouponList extends PaginationList<Coupon> {
  @Type(decoratorType(Coupon))
  results: Coupon[];
}
